<template>
	<el-config-provider :locale="locale">
		<div id="app">
			<router-view/>
		</div>
	</el-config-provider>
</template>

<script>
	import {
		ElConfigProvider
	} from 'element-plus'
	import zhCn from 'element-plus/lib/locale/lang/zh-cn'
	export default {
		components: {
			[ElConfigProvider.name]: ElConfigProvider,
		},
		data() {
			return {
				locale: zhCn,
			}
		},
		created() {
			// 初始化用户信息
			this.$store.commit('initUser')
		}
	}
</script>

<style>
	@import url("./assets/css/animate.min.css");
	@import url("./assets/css/bootstrap.min.css");
	@import url("./assets/fonts/iconfont.css");

	* {
		text-decoration: none !important;
		list-style: none !important;
	}

	::-webkit-scrollbar {

		width: 10px;

	}

	/*定义滚动条轨道 内阴影+圆角*/

	::-webkit-scrollbar-track {

		background-color: rgba(0, 0, 0, 0.1);

	}

	/*定义滑块 内阴影+圆角*/

	::-webkit-scrollbar-thumb {

		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);

		background-color: rgba(0, 0, 0, 0.1);

	}

	.el-menu--horizontal {
		border-bottom: none;
	}
</style>
